/* BaseChartResponseDto.ts */

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Utils */
import { toCamelCase } from "src/utils/helper/string-transformation";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";

/**
 * BaseChartResponseDto with generic type ChartData.
 */
export class BaseChartResponseDto<
  D,
  T extends ChartType[] | ChartType[][]
> {
  constructor(
    public total: number,
    public types: T,
    public data: D,
    public totalCohortSize?: number,
    public lookedForNoValueTotal?: number,
    public notLookedForCount?: number,
    public lookedForNoValueCount?: number
  ) {}

  static fromApi<D, T extends ChartType[] | ChartType[][]>(
    data: D,
    transformData: (data: D) => BaseChartProps<D, T>
  ) {
    const camelCaseData = toCamelCase(data);
    const dataTransformed = transformData(camelCaseData);

    return new BaseChartResponseDto<D, T>(
      dataTransformed.total,
      dataTransformed.types,
      dataTransformed.data,
      dataTransformed.totalCohortSize,
      dataTransformed.lookedForNoValueTotal,
      dataTransformed.notLookedForCount,
      dataTransformed.lookedForNoValueCount
    );
  }

  public toObject(): BaseChartProps<D, T> {
    return {
      total: this.total,
      types: this.types,
      data: this.data,
      totalCohortSize: this.totalCohortSize,
      lookedForNoValueTotal: this.lookedForNoValueTotal,
      notLookedForCount: this.notLookedForCount,
      lookedForNoValueCount: this.lookedForNoValueCount,
    };
  }
}
